export default __webpack_public_path__ + "static/media/tail-spin.86194a55.svg";